module.exports = __webpack_public_path__ + "img/by.0a7149c.svg";